enum SpotDropAlignmentOption {
  TopLeft = 'top-left',
  TopCenter = 'top-center',
  TopRight = 'top-right',

  RightTop = 'right-top',
  RightCenter = 'right-center',
  RightBottom = 'right-bottom',

  BottomLeft = 'bottom-left',
  BottomCenter = 'bottom-center',
  BottomRight = 'bottom-right',

  LeftTop = 'left-top',
  LeftCenter = 'left-center',
  LeftBottom = 'left-bottom',
}

export default SpotDropAlignmentOption;
